import React, { useEffect, useState } from 'react'
import './side-menu.styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faBell, faTrophy, faSuitcase, faGem, faMagnifyingGlass, faGear, faShoppingCart, faUserSecret, faFlag, faMap, faUsers, faListDots, faRectangleList, faListCheck, faEarthAmericas, faDiceSix, faDice, faGlobeAmericas, faToolbox } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export function switchPlayerMenu(id) {
    // const btns = document.getElementsByClassName('menu-btn')
    // for (let btn of btns) {
    //     btn.classList.remove('active');
    // }
    // document.getElementById(id).classList.add('active');
}

const PlayerSideMenu = ({ 
    gameData, 
    playerData, 
    gameElements
}) => {
    
    const location = useLocation();
    const [ path, setPath ] = useState('');
    const [ rewardCount, setRewardCount ] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (!location) return;
        setPath(location.pathname);
    }, [location])

    useEffect(() => {
        if (!playerData) return;
        if (playerData.newStuff && playerData.newStuff.length > 0) {
            let count = 0;
            for (let newStuffInfo of playerData.newStuff) {
                if (
                    newStuffInfo.display === 'reward' ||
                    newStuffInfo.display === 'prizepack' ||
                    newStuffInfo.display === 'achievement' ||
                    newStuffInfo.display === 'purchase'
                ) {
                    count++;
                }
            }
            setRewardCount(count);
        } else {
            setRewardCount(0);
        }
    }, [playerData])

    return (
        <div className='player-side-menu'>
            <div className='card-title'>My Links</div>
            <div className="g-space-1"></div>
            <div className='button-list'>
                <Link to={`/play/${gameData.path}`}>
                    <button 
                        className={
                            `g-button menu-btn ${
                                (
                                    path === `/play/${gameData.path}` || 
                                    path.includes(`/play/${gameData.path}/my`)
                                )
                                ?
                                'active' : 
                                ''
                            }`
                        } 
                        title="Home" >
                        <FontAwesomeIcon 
                            icon={faHouse} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            Home
                        </div>    
                    </button>
                </Link>
                {/* INVENTORY */}
                {
                    (gameData && gameData.access.includes('items')) && 
                    <Link to={`/play/${gameData.path}/inventory`}>
                        <button 
                        className={`g-button menu-btn ${
                            path.includes(`/play/${gameData.path}/inventory`) 
                            ? 'active' 
                            : ''}`
                        } 
                        title="My Inventory" >
                        <FontAwesomeIcon icon={faToolbox} className='btn-icon' size='xl' />
                        <div className='btn-text'>Your Inventory</div>
                    </button>
                    </Link>
                }
                {/* REWARDS */}
                {
                    (playerData) && 
                    <Link to={`/play/${gameData.path}/rewards`}>
                    <div className='notification-with-badge'>
                        <button 
                            className={
                                `${
                                    playerData.newStuff && playerData.newStuff.length > 0 
                                    ? "g-button menu-btn pending" 
                                    : "g-button menu-btn" 
                                } ${
                                    path.includes(`/play/${gameData.path}/rewards`) 
                                    ? 'active' 
                                    : ''
                                }`
                            } 
                            title="My Rewards" >
                            <FontAwesomeIcon 
                                icon={faGem} 
                                className='btn-icon' 
                                size='xl' />
                            <div 
                                className='btn-text'>
                                Your Rewards
                            </div>
                        </button>
                        {
                            (rewardCount > 0) &&
                            <div className='badge'>
                                {rewardCount.toLocaleString()}
                            </div>
                        }
                    </div>
                    </Link>
                }
                {/* STORE */}
                {
                    (gameData && gameData.access.includes('store')) &&
                    <Link to={`/play/${gameData.path}/marketplace`}>
                        <button 
                            className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/marketplace`) ? 'active' : ''}`} 
                            title="Marketplace" 
                        >
                            <FontAwesomeIcon 
                                icon={faShoppingCart} 
                                className='btn-icon' 
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Marketplace
                            </div>
                        </button>
                    </Link>
                }
                {/* SECRET CODES */}
                {
                    (gameData && gameData.access.includes('secretCodes')) &&
                    <Link to={`/play/${gameData.path}/secretcode`}>
                        <button 
                            className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/secretcode`) ? 'active' : ''}`} 
                            title="Submit a Secret Code" 
                        >
                            <FontAwesomeIcon 
                                icon={faUserSecret} 
                                className='btn-icon' 
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Submit a Secret Code
                            </div>
                        </button>
                    </Link>
                }
                {/* CHALLENGES */}
                {
                    (gameData && gameData.access.includes('challenges')) &&
                    <Link to={`/play/${gameData.path}/challenges`}>
                        <button 
                            className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/challenges`) ? 'active' : ''}`} 
                            title="Challenges" 
                        >
                            <FontAwesomeIcon 
                            icon={faFlag} 
                            className='btn-icon' 
                            size='xl' 
                        />
                            <div className='btn-text'>
                                Challenges
                            </div>
                        </button>
                    </Link>
                }
                {/* QUESTS */}
                {
                    (gameData && gameData.access.includes('quests')) &&
                    <Link to={`/play/${gameData.path}/quests`}>
                        <button 
                            className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/quests`) ? 'active' : ''}`} 
                            title="Go on a Quest" >
                            <FontAwesomeIcon 
                                icon={faMap} 
                                className='btn-icon'  
                                size='xl' 
                            />
                            <div className='btn-text'>
                                Go on a Quest
                            </div>
                        </button>
                    </Link>
                }
                {/* TEAMS */}
                {/* {
                    (gameData && gameData.access.includes('teams')) &&
                    <button 
                        className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/teams`) ? 'active' : ''}`} 
                        title="View My Teams" 
                        onClick={() => navigate('teams')}
                    >
                        <FontAwesomeIcon 
                            icon={faUsers} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            View My Teams
                        </div>
                    </button>
                } */}
                {/* LEADERBOARDS */}
                {
                    (
                        gameData && 
                        gameData.access.includes('leaderboards') 
                        &&
                        gameElements &&
                        Object.values(gameElements)
                        .filter(e => e.type === 'leaderboard').length > 0
                    ) &&
                    <Link to={`/play/${gameData.path}/leaderboards`}>
                        <button 
                            className={`g-button menu-btn ${path.includes(`/play/${gameData.path}/leaderboards`) ? 'active' : ''}`} 
                            title="Leaderboards" 
                        >
                            <FontAwesomeIcon 
                                icon={faRectangleList} 
                                className='btn-icon' 
                                size='xl' />
                            <div className='btn-text'>
                                Leaderboards
                            </div>
                        </button>
                    </Link>
                }
                <Link to={`/play/${gameData.path}/gameactivity`}>
                    <button 
                        className={`g-button menu-btn ${
                            path.includes(`/play/${gameData.path}/gameactivity`) ||
                            path.includes(`/play/${gameData.path}/transaction`) 
                            ? 'active' : ''
                        }`} 
                        title="View Game Activity" 
                    >
                        <FontAwesomeIcon 
                            icon={faGlobeAmericas} 
                            className='btn-icon' 
                            size='xl' 
                        />
                        <div className='btn-text'>
                            View Your Activity
                        </div>
                    </button>
                </Link>
            </div>
                
        </div>
  )
}

export default PlayerSideMenu;